import { isUnknownObject } from '~/shared/utils/guards'
import { toDateFormatComma } from '~/shared/utils/date'
import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { toCroppedImage } from '~/shared/utils/image'
import { EmployersTasksItemEmployerModel } from '~/models/employers-tasks/index'

export default class EmployersTasksListItemModel extends BaseModel {
  static override constructorName = 'EmployersTasksListItemModel'

  public id: number = 0
  public slug: string = ''
  public 'assignments_count': number = 0
  public 'created_at': string = ''
  public 'is_published': boolean = false
  public name: string = ''
  public requirements: string = ''
  public 'reward_image_1': string = ''
  public 'reward_image_2': string = ''
  public 'reward_image_3': string = ''
  public 'reward_name': string = ''
  public 'vacancies_count': number = 0
  public 'vk_post_link': string = ''
  public 'end_responses_datetime': string = ''
  public scores: number = 0
  public 'is_active': boolean = false
  public employer: EmployersTasksItemEmployerModel = new EmployersTasksItemEmployerModel(null)

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (data.employer) {
        this.employer = new EmployersTasksItemEmployerModel(data.employer)
      }

      this.reward_image_1 = toCroppedImage(data.reward_image_1)
      this.reward_image_2 = toCroppedImage(data.reward_image_2)
      this.reward_image_3 = toCroppedImage(data.reward_image_3)
    }

    if (this.end_responses_datetime) {
      this.end_responses_datetime = toDateFormatComma(this.end_responses_datetime)
    }
  }
}

registerModel(EmployersTasksListItemModel)
